import { ShopkeeperUpdateCheckResponse } from './../../shared/models/shopkeeper/shopkeeper-update-chek-response.type';
import { ShopkeeperService } from './../../services/shopkeeper/shopkeeper.service';
import { ModalComponent } from './../../shared/modais/modal/modal.component';
import { HeaderSort } from './../ficha-table/header-sort/header-sort';
import { FichaListaHomeQueryParams } from './model/ficha-lista-home-query-params.interface';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PesadosBrasilStorage } from './../../services/pesados-brasil/pesados-brasil.storage';
import { TipoVisualizacaoService } from './../../services/tipo-visualizacao/tipo-visualizacao.service';
import { MenuSharedService } from './../../menu/menu-shared.service';
import { LoginStorage } from './../../login/login.storage';
import { StatusModel } from './../../models/statusModel';
import { SelectProdutoComponent } from './../../shared/select-produto/select-produto.component';
import { ModalMessageComponent } from './../../shared/modais/modal-message/modal-message.component';
import {
  Component,
  OnInit,
  ViewChild,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { finalize, take, takeWhile, debounceTime } from 'rxjs/operators';
import { FichaListaSharedService } from '../ficha-lista/ficha-lista.shared.service';
import { StatusEmAnalise } from '../ficha-lista/ficha-status/ficha-status-analise-impl';
import { StatusAprovada } from '../ficha-lista/ficha-status/ficha-status-aprovada-impl';
import { StatusContratoCancelado } from '../ficha-lista/ficha-status/ficha-status-contrato-cancelado-impl';
import { StatusFechamento } from '../ficha-lista/ficha-status/ficha-status-fechamento-impl';
import { FichaStatus } from '../ficha-lista/ficha-status/ficha-status-interface';
import { StatusRecusada } from '../ficha-lista/ficha-status/ficha-status-recusada-impl';
import { FichaService } from '../ficha-veiculo.service';
import { FichaCadastroHomeFaseIdEnum } from './model/ficha-lista-home-fase-id.enum';
import { FichaListaSortStatusEnum } from './model/ficha-lista-sort-status.enum';
import { environment } from '../../../environments/environment';
import { ParceriasRodas } from './../../shared/enums/parcerias-rodas.enum';
@Component({
  selector: 'app-ficha-lista-home',
  templateUrl: './ficha-lista-home.component.html',
  styleUrls: ['./ficha-lista-home.component.css'],
})
export class FichaListaHomeComponent implements OnInit, OnDestroy {
  @ViewChild('modalMessage', { static: true })
  modalMessage: ModalMessageComponent;

  @ViewChild('produtos', { static: true })
  produtosComponent: SelectProdutoComponent;

  @ViewChild('modalUpdateLojista', { static: true })
  modalUpdateLojista: ModalComponent;

  propostasEmAnalise = [];
  quantSosPropostasEmAnalise = 0;
  propostasAprovada = [];
  quantSosPropostasAprovadas = 0;
  propostasEmFechamento = [];
  quantSosPropostasEmFechamento = 0;
  propostasRecusada = [];
  propostasContratoCancelado = [];

  propostasEmAnaliseFiltro = [];
  quantSosPropostasEmAnaliseFiltro = 0;

  isEmAnalise: boolean;
  isPesquisandoEmAnalise = false;

  isEmFechamento: boolean;
  isPesquisandoEmFechamento = false;

  isAprovada: boolean;
  isPesquisandoAprovada = false;

  isRecusada: boolean;
  isPesquisandoisRecusada = false;

  isContratoCancelado: boolean;
  isPesquisandoisContratoCancelado = false;

  isEmAnaliseFiltro: boolean;
  isPesquisandoEmAnaliseFiltro = false;

  isFilters = false;

  disableTabs = false;

  status: StatusModel[] = [];
  interval: any;
  isAlive = true;

  showLoader: boolean = false;

  isCardView: boolean;
  produtosFiltro: any;

  public isOriginador: boolean = false;
  public fichaCadastroHomeFaseIdEnum = FichaCadastroHomeFaseIdEnum;

  public queryParams: {
    size: number;
    analise: FichaListaHomeQueryParams;
    aprovada: FichaListaHomeQueryParams;
    pagamento: FichaListaHomeQueryParams;
    recusada: FichaListaHomeQueryParams;
    cancelado: FichaListaHomeQueryParams;
  } = {
    size: 30,
    analise: {
      page: 1,
      size: 30,
      sort: undefined,
      totalElements: 0,
      phaseId: FichaCadastroHomeFaseIdEnum.ANALISE,
      product: undefined,
    },
    aprovada: {
      page: 1,
      size: 30,
      sort: undefined,
      totalElements: 0,
      phaseId: FichaCadastroHomeFaseIdEnum.APROVADAS,
      product: undefined,
    },
    pagamento: {
      page: 1,
      size: 30,
      sort: undefined,
      totalElements: 0,
      phaseId: FichaCadastroHomeFaseIdEnum.PAGAMENTOS,
      product: undefined,
    },
    recusada: {
      page: 1,
      size: 30,
      sort: undefined,
      totalElements: 0,
      phaseId: FichaCadastroHomeFaseIdEnum.RECUSADAS,
      product: undefined,
    },
    cancelado: {
      page: 1,
      size: 30,
      sort: undefined,
      totalElements: 0,
      phaseId: FichaCadastroHomeFaseIdEnum.CONTRATOS_CANCELADOS,
      product: undefined,
    },
  };

  public tabSelected:
    | 'analise'
    | 'aprovada'
    | 'pagamento'
    | 'recusada'
    | 'cancelado' = 'analise';
  public loadMethods = {
    analise: () => this.loadFichaAnalise(),
    aprovada: () => this.loadFichaAprovada(),
    pagamento: () => this.loadFichaFechamento(),
    recusada: () => this.loadFichaRecusada(),
    cancelado: () => this.loadFichaContratoCancelado(),
  };

  public filterForm: FormGroup;
  public listaLojistas = [];

  public sort = {
    'propostaHome.rastreio.status.descricao': FichaListaSortStatusEnum.UNSORT,
    id: FichaListaSortStatusEnum.UNSORT,
    'propostaHome.cpfCliente': FichaListaSortStatusEnum.UNSORT,
    valorLiquido: FichaListaSortStatusEnum.UNSORT,
    'propostaHome.rastreio.usuarioAcao': FichaListaSortStatusEnum.UNSORT,
    dataInclusao: FichaListaSortStatusEnum.UNSORT,
    flagAprovadoRessalva: FichaListaSortStatusEnum.UNSORT,
    motivoRecusa: FichaListaSortStatusEnum.UNSORT,
    'lojista.nome': FichaListaSortStatusEnum.UNSORT,
    'vendedor.nome': FichaListaSortStatusEnum.UNSORT,
    nomePromotor: FichaListaSortStatusEnum.UNSORT,
    grupo2: FichaListaSortStatusEnum.UNSORT,
  };

  public platform = undefined;
  public itensPaginaHome: string[] = [];
  public loaded: boolean = false;
  public opened: boolean = false;

  constructor(
    private readonly fichaService: FichaService,
    private readonly router: Router,
    private readonly loginStorage: LoginStorage,
    private readonly menuSharedService: MenuSharedService,
    private readonly fichaListaSharedService: FichaListaSharedService,
    private readonly tipoVisualizacaoService: TipoVisualizacaoService,
    private readonly pesadosBrasilStorage: PesadosBrasilStorage,
    private readonly formBuilder: FormBuilder,
    private readonly changeRef: ChangeDetectorRef,
    private readonly shopkeeperService: ShopkeeperService
  ) {}

  ngOnInit() {
    this.filterForm = this.inicializaForm();
    this.getItensPagina();
    this.setOriginador();
    this.setOriginadorQueryParam();
    this.setPlatform();
    this.setPlatformQueryParam();
    this.isCardView = this.loginStorage.usuario.visualizacaoProposta === 'C';
    this.pesadosBrasilStorage.clear();
    this.handleFilterValueChanges();
    this.getLojistas();
    this.onClickEmAnalise();
    this.checkIsShopkeeper();
  }

  getItensPagina() {
    if (this.loginStorage.itensPorPagina) {
      this.itensPaginaHome = this.loginStorage.itensPorPagina.split(',');
    } else {
      this.fichaService
        .getItensPaginaHome()
        .pipe(take(1))
        .subscribe(
          (result) => {
            this.itensPaginaHome = result.value.split(',');
            this.loginStorage.registerItensPaginaHome(result.value);
          },
          (error) => {
            this.itensPaginaHome = environment.ITENS_PAGINA_HOME.split(',');
            this.loginStorage.registerItensPaginaHome(
              environment.ITENS_PAGINA_HOME
            );
          }
        );
    }
    this.queryParams.size = Number(this.itensPaginaHome[0]);
    Object.keys(this.queryParams).forEach((key) => {
      if (this.queryParams[key].size) {
        this.queryParams[key].size = Number(this.itensPaginaHome[0]);
      }
    });
  }

  setOriginadorQueryParam() {
    this.queryParams.analise.leadsIndicator = this.isOriginador
      ? true
      : undefined;
    this.queryParams.aprovada.leadsIndicator = this.isOriginador
      ? true
      : undefined;
    this.queryParams.pagamento.leadsIndicator = this.isOriginador
      ? true
      : undefined;
    this.queryParams.cancelado.leadsIndicator = this.isOriginador
      ? true
      : undefined;
    this.queryParams.recusada.leadsIndicator = this.isOriginador
      ? true
      : undefined;
  }

  setPlatformQueryParam() {
    this.queryParams.analise.platform = this.platform;
    this.queryParams.aprovada.platform = this.platform;
    this.queryParams.pagamento.platform = this.platform;
    this.queryParams.recusada.platform = this.platform;
    this.queryParams.cancelado.platform = this.platform;
  }

  private handleFilterValueChanges() {
    this.filterForm.valueChanges.pipe(debounceTime(700)).subscribe((value) => {
      Object.keys(this.queryParams).forEach((key) => {
        if (typeof this.queryParams[key] === 'object') {
          const queryParams: FichaListaHomeQueryParams = {
            ...this.queryParams[key],
          };
          if (value.cpfCliente) {
            queryParams.cpf = value.cpfCliente;
          } else {
            queryParams.cpf = undefined;
          }
          if (value.data) {
            queryParams.days = value.data;
          } else {
            queryParams.days = undefined;
          }
          if (value.nomeCliente) {
            queryParams.clientName = value.nomeCliente;
          } else {
            queryParams.clientName = undefined;
          }
          if (value.nomeLoja) {
            queryParams.storeId = value.nomeLoja;
          } else {
            queryParams.storeId = undefined;
          }
          if (value.numeroFicha) {
            queryParams.proposalId = value.numeroFicha;
          } else {
            queryParams.proposalId = undefined;
          }
          if (value.sos) {
            queryParams.containsSOS = value.sos;
          } else {
            queryParams.containsSOS = undefined;
          }
          if (value.statusFilter > 0) {
            queryParams.status = value.statusFilter;
          } else {
            queryParams.status = undefined;
          }
          this.queryParams[key] = queryParams;
        }
      });
      this.loadMethods[this.tabSelected]();
    });
  }

  inicializaForm() {
    return this.formBuilder.group({
      nomeLoja: [],
      nomeCliente: [],
      cpfCliente: [],
      numeroFicha: [],
      statusFilter: [],
      data: [],
      sos: [],
    });
  }

  getLojistas() {
    this.fichaService
      .getLojistaByOperador()
      .pipe(take(1))
      .subscribe(
        (res) => {
          this.listaLojistas = res.lojas;
          this.listaLojistas.sort(this.sortByName);
        }
        // () =>
        //   this.modalMessage.show(
        //     'A consulta de loja do vendedor não retornou resultados'
        //   )
      );
  }

  private sortByName(a, b): number {
    if (a.nome > b.nome) return 1;
    if (a.nome < b.nome) return -1;
    return 0;
  }

  get nomeLoja() {
    return this.filterForm.get('nomeLoja');
  }

  get nomeCliente() {
    return this.filterForm.get('nomeCliente');
  }

  get cpfCliente() {
    return this.filterForm.get('cpfCliente');
  }

  get numeroFicha() {
    return this.filterForm.get('numeroFicha');
  }

  get statusFilter() {
    return this.filterForm.get('statusFilter');
  }

  get data() {
    return this.filterForm.get('data');
  }

  get sos() {
    return this.filterForm.get('sos');
  }

  private setOriginador() {
    if (this.loginStorage.originator) {
      this.isOriginador = this.loginStorage.originator.originador;
    } else {
      this.isOriginador = false;
    }
  }

  private setPlatform() {
    const parceriasRodas = Object.keys(ParceriasRodas) as string[];
    if (this.loginStorage.usuario.parcerias.length && !parceriasRodas.some(p => p === this.loginStorage.usuario.parcerias[0].chave)) {
      this.platform = this.loginStorage.usuario.parcerias[0].chave;
    } else {
      this.platform = undefined;
    }
  }

  ngOnDestroy() {
    clearInterval(this.interval);
    this.isAlive = false;
  }

  private initObservableAgenteChange() {
    this.menuSharedService.onChangeAgente
      .pipe(takeWhile(() => this.isAlive))
      .subscribe(() => {
        this.loadMethods[this.tabSelected]();
        this.setOriginador();
      });
  }

  private initObservableReloadFichas() {
    this.fichaListaSharedService.reloadFichaListaObservable
      .pipe(takeWhile(() => this.isAlive))
      .subscribe(() => {
        this.loadMethods[this.tabSelected]();
      });
  }

  refreshFichas() {
    if (
      !this.isPesquisandoEmAnalise &&
      !this.isPesquisandoAprovada &&
      !this.isPesquisandoEmFechamento &&
      !this.isPesquisandoisRecusada &&
      !this.isPesquisandoisContratoCancelado
    ) {
      this.loadMethods[this.tabSelected]();
    }
  }

  onChangeFiltroProdutos(produtosFiltro) {
    this.produtosFiltro = produtosFiltro.map((ele) => {
      return {
        descricao: ele.descricaoNormalized,
        checked: ele.checked,
      };
    });

    if (
      this.produtosFiltro &&
      this.produtosFiltro[0] &&
      this.produtosFiltro[0].descricao
    ) {
      this.queryParams[this.tabSelected].product =
        this.produtosFiltro[0].descricao;
      this.loadMethods[this.tabSelected]();
    } else {
      this.queryParams[this.tabSelected].product = undefined;
      this.loadMethods[this.tabSelected]();
    }

    this.initObservableAgenteChange();
    this.initObservableReloadFichas();
  }

  createDataFilterProdutos(idFase) {
    return {
      idFase,
      produtos: this.produtosFiltro,
    };
  }

  private loadFichaContratoCancelado() {
    if (this.showContratoCancelado) {
      this.fichaService
        .getAllProposalByPhaseIdAndProduct({
          ...this.queryParams.cancelado,
          page: this.queryParams.cancelado.page - 1,
        })
        .pipe(finalize(() => (this.isPesquisandoisRecusada = false)))
        .subscribe(
          (res) => {
            this.propostasContratoCancelado = res.proposals;
            this.queryParams.cancelado.totalElements =
              res.pagination.totalElements;
          },
          () => (this.propostasContratoCancelado = [])
        );
    }
  }

  private loadFichaRecusada() {
    this.isPesquisandoisRecusada = true;
    this.fichaService
      .getAllProposalByPhaseIdAndProduct({
        ...this.queryParams.recusada,
        page: this.queryParams.recusada.page - 1,
      })
      .pipe(finalize(() => (this.isPesquisandoisRecusada = false)))
      .subscribe(
        (res) => {
          this.propostasRecusada = res.proposals;
          this.queryParams.recusada.totalElements =
            res.pagination.totalElements;
        },
        () => (this.propostasRecusada = [])
      );
  }

  private loadFichaFechamento() {
    this.isPesquisandoEmFechamento = true;
    this.quantSosPropostasEmFechamento = 0;
    this.fichaService
      .getAllProposalByPhaseIdAndProduct({
        ...this.queryParams.pagamento,
        page: this.queryParams.pagamento.page - 1,
      })
      .pipe(finalize(() => (this.isPesquisandoEmFechamento = false)))
      .subscribe(
        (res) => {
          this.propostasEmFechamento = res.proposals;
          this.queryParams.pagamento.totalElements =
            res.pagination.totalElements;
          this.quantSosPropostasEmFechamento = res.totalSOS;
        },
        () => (this.propostasEmFechamento = [])
      );
  }

  private loadFichaAprovada() {
    this.isPesquisandoAprovada = true;
    this.quantSosPropostasAprovadas = 0;
    this.fichaService
      .getAllProposalByPhaseIdAndProduct({
        ...this.queryParams.aprovada,
        page: this.queryParams.aprovada.page - 1,
      })
      .pipe(finalize(() => (this.isPesquisandoAprovada = false)))
      .subscribe(
        (res) => {
          this.propostasAprovada = res.proposals;
          this.queryParams.aprovada.totalElements =
            res.pagination.totalElements;
          this.quantSosPropostasAprovadas = res.totalSOS;
        },
        () => this.propostasAprovada
      );
  }

  private loadFichaAnalise() {
    this.quantSosPropostasEmAnalise = 0;
    this.isPesquisandoEmAnalise = true;
    this.fichaService
      .getAllProposalByPhaseIdAndProduct({
        ...this.queryParams.analise,
        page: this.queryParams.analise.page - 1,
      })
      .pipe(finalize(() => (this.isPesquisandoEmAnalise = false)))
      .subscribe(
        (value) => {
          this.propostasEmAnalise = value.proposals;
          this.queryParams.analise.totalElements =
            value.pagination.totalElements;
          this.quantSosPropostasEmAnalise = value.totalSOS;
        },
        () => (this.propostasEmAnalise = [])
      );
  }

  onChangeView(status) {
    if (status !== this.isCardView) {
      this.isCardView = status;
      this.saveTipoVisualizacao(this.isCardView);
    }
  }

  private saveTipoVisualizacao(isCardView: boolean): void {
    this.showLoader = true;

    this.tipoVisualizacaoService
      .setVisualizacao({
        idAgente: this.loginStorage.usuario.id,
        tipoVisualizacao: isCardView ? 'C' : 'L',
      })
      .pipe(
        take(1),
        finalize(() => (this.showLoader = false))
      )
      .subscribe();
  }

  onClickEmAnalise(): void {
    this.hideAllTabs();
    this.tabSelected = 'analise';
    this.isEmAnalise = true;
    this.setStatus(new StatusEmAnalise());
    this.changeRef.detectChanges();
    this.queryParams.analise.page = 1;
    this.changeRef.detectChanges();
    this.loadFichaAnalise();
  }

  onClickEmFechamento(): void {
    this.hideAllTabs();
    this.tabSelected = 'pagamento';
    this.isEmFechamento = true;
    this.setStatus(new StatusFechamento());
    this.changeRef.detectChanges();
    this.queryParams.pagamento.page = 1;
    this.changeRef.detectChanges();
    this.loadFichaFechamento();
  }

  onClickEmAprovada(): void {
    this.hideAllTabs();
    this.tabSelected = 'aprovada';
    this.isAprovada = true;
    this.setStatus(new StatusAprovada());
    this.changeRef.detectChanges();
    this.queryParams.aprovada.page = 1;
    this.changeRef.detectChanges();
    this.loadFichaAprovada();
  }

  onClickEmRecusada(): void {
    this.hideAllTabs();
    this.tabSelected = 'recusada';
    this.isRecusada = true;
    this.setStatus(new StatusRecusada());
    this.changeRef.detectChanges();
    this.queryParams.recusada.page = 1;
    this.changeRef.detectChanges();
    this.loadFichaRecusada();
  }

  onClickEmContratoCancelado(): void {
    this.hideAllTabs();
    this.tabSelected = 'cancelado';
    this.isContratoCancelado = true;
    this.setStatus(new StatusContratoCancelado());
    this.changeRef.detectChanges();
    this.queryParams.cancelado.page = 1;
    this.changeRef.detectChanges();
    this.loadFichaContratoCancelado();
  }

  private hideAllTabs() {
    this.isEmAnalise = false;
    this.isEmFechamento = false;
    this.isAprovada = false;
    this.isRecusada = false;
    this.isContratoCancelado = false;
  }

  private setStatus(status: FichaStatus): void {
    this.status = status.getStatus();
  }

  quantidadeSosAnalise(data) {
    this.quantSosPropostasEmAnalise = data;
  }
  quantidadeSosAprovada(data) {
    this.quantSosPropostasAprovadas = data;
  }
  quantidadeSosFechamento(data) {
    this.quantSosPropostasEmFechamento = data;
  }

  addFicha() {
    if (this.loginStorage.usuario.excedeProducao === 'N') {
      this.loginStorage.usuario.parcerias.length === 0
        ? this.router.navigate(['/nova'])
        : this.router.navigate(['produtos/cdcloja/ecommerce']);
    } else {
      this.modalMessage.show(
        'Excedido o percentual de produção permitido para o mês.'
      );
    }
  }

  pageChanged(event: any): void {
    if (this.queryParams[this.tabSelected].page === event.page) {
      return;
    }
    this.queryParams[this.tabSelected] = {
      ...this.queryParams[this.tabSelected],
      page: event.page,
    };
    this.loadMethods[this.tabSelected]();
  }
  get showContratoCancelado() {
    return (this.produtosComponent.produtos || [])
      .map((item) => item.descricao)
      .includes('CDC LOJA');
  }

  onChangePageSize(size) {
    this.queryParams.size = size;
    Object.keys(this.queryParams).forEach((param) => {
      if (this.queryParams[param] && this.queryParams[param].size) {
        this.changeRef.detectChanges();
        this.queryParams[param].page = 1;
        this.changeRef.detectChanges();
        this.queryParams[param].size = this.queryParams.size;
      }
    });
    this.loadMethods[this.tabSelected]();
  }

  ordenar(elemento: HeaderSort) {
    const sort: string[] = [];

    Object.keys(this.sort).forEach((key) => {
      if (elemento.column === key) {
        sort.push(`${key},${elemento.direction}`);
      }
    });

    this.queryParams[this.tabSelected].sort = sort;
    this.loadMethods[this.tabSelected]();
  }

  checkIsShopkeeper() {
    if (this.loginStorage.usuario.isLojista) {
      this.shopkeeperService
        .checkShopkeeper(String(this.loginStorage.usuario.lojaTO.id))
        .pipe(
          take(1),
          finalize(() => (this.loaded = true))
        )
        .subscribe((res: ShopkeeperUpdateCheckResponse) => {
          if (res.merchant.mustUpdate) {
            this.opened = true;
            this.loginStorage.registerShopkeeperInfo(res);
            this.modalUpdateLojista.show();
          }
        });
    }
  }

  onCloseUpdateShopkeeper() {
    this.modalUpdateLojista.hide();
  }
}
